import React from 'react'
import Menu from './Menu'

const Navbar = () => {

    return (
      <header>
        <div className="container header-wrapper">
          <h1 id="logo">
            <a href="/">
              <span>F</span>ilip Krawczyk
            </a>
          </h1>
          <Menu />
        </div>
      </header>
    );
}

export default Navbar
